import { Base } from './base.model';

export interface Module extends Base {
  name: string;
  description: string;
  version: string;
  category: 'CRM' | 'HR' | 'FINANCE' | 'INVENTORY' | 'CUSTOM';
  isActive: boolean;
  clientId: string;
  imageUrl?: string;
  entityCount: number;
  ootbEntityCount: number;
  pageCount: number;
  roleCount: number;
  functionCount?: number;
  // Note: Entities, pages, roles, and functions are stored as subcollections
  // modules/{moduleId}/entities
  // modules/{moduleId}/ootbEntities
  // modules/{moduleId}/pages
  // modules/{moduleId}/roles
  // modules/{moduleId}/functions
}

/**
 * Validates module name - no 'system' word and no special characters
 */
export function validateModuleName(name: string): { valid: boolean; error?: string } {
  if (!name || !name.trim()) {
    return { valid: false, error: 'Module name is required' };
  }
  
  if (name.toLowerCase().includes('system')) {
    return { valid: false, error: 'Module name cannot contain the word "system"' };
  }
// Only allow alphanumeric characters (no spaces, hyphens, or underscores)
if (!/^[a-zA-Z0-9]+$/.test(name)) {
    return { valid: false, error: 'Module name can only contain letters and numbers' };
}
  
  return { valid: true };
}

export interface ModuleEntity {
  name: string;
  description: string;
  data: any; // TypeData[] structure from entity.model
}

export interface ModulePage {
  name: string;
  type: string;
  sections: any[]; // Sections[] from page.model
  entites: string[];
  localVariable: any;
  functions: any[];
}

export interface ModuleRole {
  name: string;
  permissions: string[];
  description: string;
}
